// src/components/ProductCard.jsx
import React from "react";
import { ShoppingCart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import RatingStars from "./RatingStars";

const PRIMARY_COLOR = "text-teal-400";
const ACCENT_BG = "bg-teal-600 hover:bg-teal-500";
const CARD_BG = "bg-gray-800";
const TEXT_COLOR = "text-gray-100";

const ProductCard = ({ product, onClick }) => {
  const navigate = useNavigate();
  const handleClick = onClick ? onClick : () => navigate(`/product/${product.slug}`);

  // --- FIXED CATEGORY LOGIC ---
  const categoryName =
    product?.category_name ||
    product?.category ||
    product?.category_slug ||
    product?.["category-slug"] ||
    "N/A";

  // --- FIXED VARIABLES ---
  const imageUrl = product?.image
    ? product.image.startsWith("/")
      ? product.image
      : `/${product.image}`
    : "/products/default.jpg";
  const price = product?.price ?? 0;
  const rating = product?.rating ?? 0;
  const reviewCount = product?.reviewCount ?? 0;

  return (
    <div
      onClick={handleClick}
      className={`${CARD_BG} p-4 sm:p-5 rounded-xl border border-gray-700 shadow-lg cursor-pointer flex flex-col`}
    >
      {/* Image + Category */}
      <div className="relative w-full overflow-hidden rounded-lg">
        <div className="w-full h-48 sm:h-56 md:h-60 bg-gray-700 flex items-center justify-center">
          <img
            src={imageUrl}
            alt={product.name}
            loading="lazy"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/assets/products/default.jpg";
            }}
            className="w-full h-full object-cover rounded-lg"
          />
        </div>

        <span className="absolute top-2 right-2 bg-gray-900 text-xs sm:text-sm font-semibold px-2 sm:px-3 py-1 rounded-full text-white border border-teal-500">
          {categoryName}
        </span>
      </div>

      {/* Product Name */}
      <h2 className={`text-base sm:text-lg md:text-xl font-semibold ${TEXT_COLOR} mb-1 truncate`}>
        {product.name}
      </h2>

      {/* Rating */}
      <div className="flex items-center text-xs sm:text-sm text-gray-400 mb-3">
        <RatingStars rating={rating} />
        {reviewCount > 0 && <span className="ml-2">({reviewCount} reviews)</span>}
      </div>

      {/* Price + Button */}
      <div className="mt-auto flex justify-between items-center pt-2">
        <p className={`${PRIMARY_COLOR} font-extrabold text-lg sm:text-xl md:text-2xl`}>
          £{price.toFixed(2)}
        </p>

        <button
          onClick={(e) => e.stopPropagation() || handleClick()}
          className={`${ACCENT_BG} text-white px-2 sm:px-3 py-1 sm:py-1.5 rounded-lg text-xs sm:text-sm font-semibold flex items-center transition-transform duration-200 hover:scale-105`}
        >
          View <ShoppingCart className="w-3 h-3 sm:w-4 sm:h-4 ml-1" />
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
